import { BaseApi } from '@/main/baseApi';

import {
	DependentTableNames,
	DMS_MODULE,
	NAME,
} from './constants';
import { PARTS_INVENTORY_ADJUSTMENTS } from '../constants';

class PartsInventoryAdjustmentProvider extends BaseApi {
	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case PARTS_INVENTORY_ADJUSTMENTS:
				return `/${DMS_MODULE}/${PARTS_INVENTORY_ADJUSTMENTS}/Schema`;
			default:
				throw new Error(`schema for ${tableName} is not implemented yet`);
		}
	}

	async saveInventoryAdjusments(dto: any) {
		return this.post(`/${DMS_MODULE}/${'NdSklad'}/InventoryAdjusments`, dto);
	}

	async approveInventoryAdjustment(dto: any) {
		return this.post(`/${DMS_MODULE}/${'NdSklad'}/ApproveRejectInventoryAdjustment`, dto);
	}

	async sendNotification(dto: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/SendNotification`, dto);
	}

	async getWorkflowApprovalConfig(approvaltype: string, approvallevel: string) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetWorkflowApprovalConfig?approvaltype=${approvaltype}&approvallevel=${approvallevel}`);
	}

	async sendEmailNotification(dto: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/SendMailNotification`, dto);
	}
}

export const apiProvider = new PartsInventoryAdjustmentProvider(DMS_MODULE, NAME);
